import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { applyEnvBranding } from "./env";

// Before React mounts: the tab title and favicon are how you find the right
// portal among several open tabs, and they should be right from the first
// paint rather than after a render.
applyEnvBranding();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
